import React, { useRef, useState, useEffect } from "react";
import { CustomTextField } from "../Utility/utility";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { Button } from "@material-ui/core";
import filterNew from "images/filterNew.svg";
import "../style.css";
import downloadWhite from "images/downloadWhite.svg";
import View2AColumnsTable from "./View2AColumns";
import { useDispatch, useSelector } from "react-redux";
import View2BColumnsTable from "./View2BColumns";
import NoData from "../Utility/NoData";
import ReactPaginate from "react-paginate";
import { setViewTableData } from "./action";

const View = (props) => {
  const debounceTimeout = useRef(null);
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");

  const { viewTableData, totalPagesView, loaderStatus } = useSelector(
    (store) => store.gstr2a2bNewFetchReducer
  );
  const { isChecked } = useSelector((store) => store.gstr2a2bNewCommonReducer);

  // Clear search when isChecked changes
  useEffect(() => {
    setSearchValue("");
    props.setSearchView("");
  }, [isChecked]);

  const handleInputChange = (event) => {
    const search = event;
    if (search?.length > 50) {
      return;
    }
    props.setSearchView(search);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      props.handleSubmit(search, false, false);
    }, 500);
  };

  useEffect(() => {
    return () => dispatch(setViewTableData([]));
  }, []);
  
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <div style={{ width: "35%" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            variant="outlined"
            size="small"
            value={searchValue}
            onChange={(event) => {
              setSearchValue(event.target.value);
              handleInputChange(event.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Button
          onClick={props.handleOpen}
          disabled={loaderStatus}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            textTransform: "capitalize",
            height: "32px",
            marginTop: "0.4em",
            marginLeft: "1.5em",
            fontSize: "12px",
          }}
        >
          <img
            src={filterNew}
            alt="filter"
            style={{ width: "30px", height: "18px" }}
          />
          Filter
        </Button>
        <Button
          onClick={props.handleDownloadView}
          disabled={loaderStatus}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "5px",
            marginLeft: "1.5em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
          Download
        </Button>
      </div>

      {viewTableData?.length > 0 ? (
        <>
          <div style={{ marginTop: "1em", width: "100%", overflowX: "scroll" }}>
            <div
              style={{ height: "25em", width: "750%", overflowY: "scroll" }}
              className="light-border-gstr2a2bnew-table"
            >
              {isChecked == true ? (
                <View2AColumnsTable viewTableData={viewTableData} />
              ) : (
                <View2BColumnsTable viewTableData={viewTableData} />
              )}
            </div>
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPagesView}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
        </>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default View;
